// extracted by mini-css-extract-plugin
export default {"auth":"style_auth__zQCuV","formItem":"style_formItem__0FWqI","title":"style_title__OV50J","formRegister":"style_formRegister__L6+lk"};